import { useQuery } from 'react-query';
import { getSceneDetail, type SceneDetailResponse } from '../../services/sceneService';
import { SCENE_QUERY_KEYS } from '../queryKeys';

const DEFAULT_POLL_INTERVAL_MS = 10 * 1000;

export interface UseGetSceneDetailOptions {
  enabled?: boolean;
  /** 폴링 사용 시 refetch 간격(ms). false/미설정 시 폴링 없음 */
  refetchInterval?: number | false;
}

export function useGetSceneDetail(sceneId: string, options?: UseGetSceneDetailOptions) {
  const { enabled = true, refetchInterval } = options ?? {};

  return useQuery<SceneDetailResponse, Error, SceneDetailResponse>(
    SCENE_QUERY_KEYS.sceneDetail(sceneId),
    () => getSceneDetail({ sceneId }),
    {
      enabled: !!sceneId && enabled,
      refetchInterval: refetchInterval ?? false,
      /** isPrimaryReady가 true면 폴링 중단 (refetchInterval이 설정된 경우) */
      refetchIntervalInBackground: !!refetchInterval
    }
  );
}

export const SCENE_READY_POLL_INTERVAL_MS = DEFAULT_POLL_INTERVAL_MS;
